import geniusForm from "../assets/logos/Genius-forum.png";
import stichtingify from "../assets/logos/stichtingify.png";
import diaries from "../assets/logos/diaries.png";
import library from "../assets/logos/library.png";
import number_discovery from "../assets/logos/number-discovery.png";
import personal_website from "../assets/logos/personal_website.png";

const projects = {
  english: [
    {
      title: "Number Discovery",
      img: number_discovery,
      side: "Front-End application",
      status: "Published",
      personal: false,
      description:
        "( IQ game ) The aim of this game is to discover the random number that the computer reserves.",
      date: "Dec 2022",
      code: "https://github.com/amerbarnawi/number-discovery",
      live: "https://number-discovery.netlify.app/",
    },
    {
      title: "Personal website",
      img: personal_website,
      side: "Front-End application",
      status: "Private code",
      personal: true,
      description: "My personal website ( CV ).",
      date: "Dec 2022",
      live: "https://abarnawi.netlify.app/",
    },
    {
      title: "Stichtingify (Graduation project)",
      img: stichtingify,
      side: "Full-Stack application",
      status: "Published",
      personal: false,
      description:
        "Application that non-profits can use to organize special events for refugees to integrate them more efficiently.",
      date: "Oct 2022 - Dec 2022",
      code: "https://github.com/amerbarnawi/stichtingify-final-project",
      live: "https://c38-group3.herokuapp.com/",
    },
    {
      title: "Genius forum",
      img: geniusForm,
      side: "Full-Stack application",
      status: "Published",
      personal: true,
      description:
        "It is a platform that provides a forum for social networking regarding scientific challenges.",
      date: "Oct 2022",
      code: "https://github.com/amerbarnawi/Genius-forum",
    },
    {
      title: "My Diary",
      img: diaries,
      side: "Full-Stack application",
      status: "Published",
      personal: true,
      description:
        "An application that provides the possibility of writing diaries and memories and retrieving them.",
      date: "Sep 2022",
      code: "https://github.com/amerbarnawi/Diaries",
    },
    {
      title: "Open your mind library",
      img: library,
      side: "Front-End",
      status: "Published",
      personal: true,
      description:
        "An application to display some interesting features, in addition to the ability to search for specific books by the name of the book or the name of the author, in addition to viewing the details about the book.",
      date: "Jul 2022",
      code: "https://github.com/amerbarnawi/Using-APIs-Project",
      live: "https://amerbarnawi.github.io/Using-APIs-Project/index.html",
    },
  ],
  arabic: [
    {
      title: "إكتشاف الرقم",
      img: number_discovery,
      side: "تطبيق واجهة أمامية",
      status: "الكود مفتوح المصدر",
      personal: false,
      description:
        "لعبة ذكاء, و المطلوب فيها اكتشاف الرقم الذي يحتفظ به الكمبيوتر",
      date: "Dec 2022",
      code: "https://github.com/amerbarnawi/number-discovery",
      live: "https://number-discovery.netlify.app/",
    },
    {
      title: "موقع الويب الشخصي",
      img: personal_website,
      side: "تطبيق واجهة أمامية",
      status: "الكود خاص - مغلق",
      personal: true,
      description: "موقعي الشخصي وهو بمثابة سيرة ذاتية",
      date: "Dec 2022",
      live: "https://abarnawi.netlify.app/",
    },
    {
      title: "مشروع التخرج: مؤسسات",
      img: stichtingify,
      side: "تطبيق يشمل الواجهتين الأمامية والخلفية",
      status: "الكود مفتوح المصدر",
      personal: false,
      description:
        "تطبيق يمكن المنظمات غير الربحية في أوروبا من تنظيم مناسبات خاصة للاجئين للمساعدة في دمجهم بكفاءة أكبر ",
      date: "Oct 2022 - Dec 2022",
      code: "https://github.com/amerbarnawi/stichtingify-final-project",
      live: "https://c38-group3.herokuapp.com/",
    },
    {
      title: "منتدى العباقرة",
      img: geniusForm,
      side: "تطبيق يشمل الواجهتين الأمامية والخلفية",
      status: "الكود مفتوح المصدر ",
      personal: true,
      description:
        "التطبيق عبارة عن منتدى للتواصل الإجتماعي فيما يتعلق بالتحديات والألغاز العلمية",
      date: "Oct 2022 - حتى الآن",
      code: "https://github.com/amerbarnawi/Genius-forum",
    },
    {
      title: "مذكراتي",
      img: diaries,
      side: "تطبيق يشمل الواجهتين الأمامية والخلفية",
      status: "الكود مفتوح المصدر",
      personal: true,
      description:
        "التطبيق يوفر امكانية كتابة المذكرات و اليوميات واسترجها وتعديلها وحذفها",
      date: "Sep 2022",
      code: "https://github.com/amerbarnawi/Diaries",
    },
    {
      title: "مكتبة افتح عقلك",
      img: library,
      side: "تطبيق واجهة أمامية",
      status: "الكود مفتوح المصدر",
      personal: true,
      description:
        "المكتبة: هو عبارة عن تطبيق يوفر بعض المميزات الممتعة مثل صورة ناسا اليومية وبعض المقولات والحكم, بالإضافة إلى إمكانية البحث عن كتاب معين من خلال اسم الكتاب أو اسم الكاتب أو حتى جزء من العنوان, بالإضافة إلى امكانية الإضطلاع على تفاصيل الكتاب.",
      date: "Jul 2022",
      code: "https://github.com/amerbarnawi/Using-APIs-Project",
      live: "https://amerbarnawi.github.io/Using-APIs-Project/index.html",
    },
  ],
};

export default projects;
